export default "__VITE_ASSET__Bn7Nz_iP__"